import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  dateFilterAdministracion: null
};

const slice = createSlice({
  name: 'dagpacketFiltros',
  initialState,
  reducers: {
    // START LOADING
    setDateFilterAdm: (state, action) => {
      const date = action.payload;

      state.dateFilterAdministracion = date;
    }
  }
});

export const { setDateFilterAdm } = slice.actions;

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
